import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Slide, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CircularProgress from '@mui/material/CircularProgress';
import { validarCambioPassword } from "global/util/validators";
import { TransitionProps } from '@mui/material/transitions';
import { Link } from "react-router-dom";
import { getJson, isHttpError, postJson } from "api/httpClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
interface NewUser {
    sub: string;
    name: string;
    token: string;
    password?: string;
}
interface Response {
    payload: NewUser;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const getHttpErrorMessage = (error: unknown, fallback: string) => {
    if (!isHttpError(error)) {
        return fallback;
    }

    const data = error.response.data as { message?: string } | null;
    return data?.message ?? fallback;
};


export const Confirm = () => {
    const [isLoading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState(false);
    const [newUser, setNewUser] = useState<NewUser | null>(null);
    const [searchParams] = useSearchParams();
    const [loginError, setLoginError] = useState('');
    const token = searchParams.get("token");

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const handleClickShowPasswordConfirm = () => setShowPasswordConfirm((show) => !show);
    const handleMouseDownPasswordConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const [showErrors, setShowErrors] = useState<any>({ state: true, errors: [] })

    const hasFetchedRef = React.useRef(false);

    if (token && !hasFetchedRef.current) {
        hasFetchedRef.current = true;

        const fetchToken = async () => {
            try {
                setLoading(true);
                const data = await getJson<NewUser>(`${API_BASE_URL}/validate-token?token=${token}`);
                console.log("token payload:" + JSON.stringify(data));
                setNewUser(data);
            } catch (error) {
                console.error("Error al validar token:", error);
                setLoginError(getHttpErrorMessage(error, 'Ocurrió un error inesperado al validar el token.'));
            } finally {
                setLoading(false);
            }
        };

        fetchToken();
    }

    useEffect(() => {
        if (!token) return;

        let alreadyFetched = false;

        const fetchToken = async () => {
            if (alreadyFetched) return;
            alreadyFetched = true;

            try {
                setLoading(true);
                const data = await getJson<NewUser>(`${API_BASE_URL}/validate-token?token=${token}`);
                console.log("token payload:" + JSON.stringify(data));
                setNewUser(data);
            } catch (error) {
                console.error("Error al validar token:", error);

                setLoginError(getHttpErrorMessage(error, 'Error inesperado al validar el token.'));
            } finally {
                setLoading(false);
            }
        };

        //fetchToken();
    }, [token]);

    const handleCloseModal = () => {
        setUserCreated(false);
    };

    const handleCreate = async () => {
        if(isLoading){
            return;
        }
        const validationResult = validarCambioPassword({ passwordOld: "", password, confirmPassword });
        setShowErrors(validationResult);

        if (!validationResult.state) {
            console.log("tiene errores");
            return;
        }
        if (!showErrors.state) {
            console.log("tiene errores");
            return;
        }
        if (newUser === null) {
            console.log("no se recibió el usuario");
            return;
        }
        let resp;
        try {
            setLoading(true);
            console.log(JSON.stringify(newUser));
            const input: NewUser = { ...newUser, password: password };
            resp = await postJson<any>(`${API_BASE_URL}/confirm-user`, input);
            console.log(JSON.stringify(resp));
            setUserCreated(true);
        } catch (error) {
            console.error("Error al crear contraseña:", error);
            if (isHttpError(error)) {
                console.error("Error response:", JSON.stringify(error.response));
            }
            setLoginError(getHttpErrorMessage(error, 'Error inesperado al crear contraseña.'));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <Box
                className="home-component"
                sx={{ width: 400, marginTop: 3, marginBottom: 5 }}
            >
                <div className="registration-container">
                    <h2>Crea tu contraseña</h2>

                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Contraseña nueva</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Contraseña nueva"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined css-1jy569b-MuiFormLabel-root-MuiInputLabel-root" >
                            La contraseña debe contener números, caracteres especiales, mayúsculas y minúsculas
                        </label>
                    </FormControl>

                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Confirmar contraseña nueva</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPasswordConfirm ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPasswordConfirm}
                                        onMouseDown={handleMouseDownPasswordConfirm}
                                        edge="end"
                                    >
                                        {showPasswordConfirm ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Confirmar contraseña nueva"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </FormControl>
                    {
                        !showErrors.state ?
                            <>
                                {showErrors.errors.map((error: any) => {
                                    return <p style={{ color: "red" }}>*{error.message}</p>
                                })}
                            </> :
                            <></>
                    }
                    {
                        loginError === '' ?
                            <></> :
                            <p style={{ color: "red" }}>*{loginError}</p>
                    }
                    <Stack spacing={1} direction="row" justifyContent="center" marginTop={2}>
                        <Button variant="contained" onClick={handleCreate} className="app-primary-button" >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Crear contraseña"}
                        </Button>
                    </Stack>
                </div>

                <Dialog
                    open={userCreated}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleCloseModal}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Confirmación de nueva contraseña"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Ahora ya puedes ingresar utilizando tu correo electr&oacute;nico y la nueva contraseña.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Link to={`/login`} onClick={handleCloseModal}>
                            <Button>Aceptar</Button>
                        </Link>
                    </DialogActions>

                </Dialog>
            </Box>
        </div>
    )
}
